(function () {
  'use strict';


  function initBackLink(root) {
    root.querySelectorAll('[data-shfty-return-link]').forEach(function (link) {
      var url = new URL(location.href);
      var from = url.searchParams.get('shfty_from');
      var returnUrl = new URL(link.dataset.dropRoot || '/', location.origin);
      returnUrl.searchParams.set('shfty_return', from || 'collection');
      link.href = returnUrl.pathname + returnUrl.search;
    });
  }

  function initScrollHint(root) {
    root.querySelectorAll('[data-shfty-scroll-shell]').forEach(function (shell) {
      if (shell.dataset.scrollReady) return;
      shell.dataset.scrollReady = 'true';
      var scroller = shell.querySelector('[data-shfty-scroll]');
      if (!scroller) return;
      function update() {
        shell.dataset.scrollMore = String(scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight > 12);
      }
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(update);
        observer.observe(scroller);
        if (scroller.firstElementChild) observer.observe(scroller.firstElementChild);
      }
      update();
    });
  }

  function init(root) {
    initBackLink(root);
    initScrollHint(root);
    root.querySelectorAll('[data-shfty-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = 'true';

      var track = gallery.querySelector('[data-gallery-track]');
      var slides = gallery.querySelectorAll('.shfty-product-slide');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var previous = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      var counter = gallery.querySelector('[data-gallery-counter]');
      var index = 0;
      if (!track || !slides.length) return;

      function update() {
        var width = track.clientWidth;
        index = Math.max(0, Math.min(slides.length - 1, width ? Math.round(track.scrollLeft / width) : 0));
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-pressed', String(i === index));
        });
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      }

      function gotoSlide(i) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({left: index * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        update();
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gotoSlide(Number(thumb.dataset.index));
        });
      });
      if (previous) previous.addEventListener('click', function () { gotoSlide(index - 1); });
      if (next) next.addEventListener('click', function () { gotoSlide(index + 1); });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); gotoSlide(index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); gotoSlide(index - 1); }
      });

      var scheduled = false;
      track.addEventListener('scroll', function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          update();
        });
      }, {passive: true});
      window.addEventListener('resize', update, {passive: true});
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();